import { jsx as i, jsxs as Q, Fragment as Ie } from "react/jsx-runtime";
import * as r from "react";
import * as Ee from "react-dom";
import { c as vt, u as B, a as gt, P as M, b as P, f as z, e as St, h as wt, d as Pe } from "./index-BwqhVa-H.js";
import { u as Te, a as yt } from "./index-DfspMmaX.js";
import { P as xt, D as Ct } from "./index-B-Qjqgjx.js";
import { c as _e, A as bt, h as It, u as Tt, R as Nt, F as Pt, C as Rt, a as Et, b as _t } from "./Combination-Te-rCbiT.js";
import { a as Mt } from "./index-Boityy6u.js";
import { c as j } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { C as Me } from "./chevron-down-CAS1zUor.js";
import { C as At } from "./chevron-up-Bxd1ocyl.js";
import { C as Ot } from "./check-CVfLJTWr.js";
function Re(t, [o, e]) {
  return Math.min(e, Math.max(o, t));
}
function Dt(t) {
  const o = r.useRef({ value: t, previous: t });
  return r.useMemo(() => (o.current.value !== t && (o.current.previous = o.current.value, o.current.value = t), o.current.previous), [t]);
}
var Lt = [" ", "Enter", "ArrowUp", "ArrowDown"], kt = [" ", "Enter"], ee = "Select", [de, ue, Bt] = gt(ee), [re] = vt(ee, [
  Bt,
  _e
]), pe = _e(), [Vt, Y] = re(ee), [Ht, Ut] = re(ee), Ae = (t) => {
  const {
    __scopeSelect: o,
    children: e,
    open: s,
    defaultOpen: c,
    onOpenChange: p,
    value: a,
    defaultValue: l,
    onValueChange: n,
    dir: f,
    name: g,
    autoComplete: y,
    disabled: T,
    required: N,
    form: I
  } = t, d = pe(o), [v, x] = r.useState(null), [u, h] = r.useState(null), [A, O] = r.useState(!1), ne = yt(f), [R, L] = Pe({
    prop: s,
    defaultProp: c ?? !1,
    onChange: p,
    caller: ee
  }), [K, X] = Pe({
    prop: a,
    defaultProp: l,
    onChange: n,
    caller: ee
  }), V = r.useRef(null), H = v ? I || !!v.closest("form") : !0, [$, U] = r.useState(/* @__PURE__ */ new Set()), F = Array.from($).map((E) => E.props.value).join(";");
  return /* @__PURE__ */ i(Et, { ...d, children: /* @__PURE__ */ Q(
    Vt,
    {
      required: N,
      scope: o,
      trigger: v,
      onTriggerChange: x,
      valueNode: u,
      onValueNodeChange: h,
      valueNodeHasChildren: A,
      onValueNodeHasChildrenChange: O,
      contentId: Te(),
      value: K,
      onValueChange: X,
      open: R,
      onOpenChange: L,
      dir: ne,
      triggerPointerDownPosRef: V,
      disabled: T,
      children: [
        /* @__PURE__ */ i(de.Provider, { scope: o, children: /* @__PURE__ */ i(
          Ht,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: r.useCallback((E) => {
              U((k) => new Set(k).add(E));
            }, []),
            onNativeOptionRemove: r.useCallback((E) => {
              U((k) => {
                const W = new Set(k);
                return W.delete(E), W;
              });
            }, []),
            children: e
          }
        ) }),
        H ? /* @__PURE__ */ Q(
          rt,
          {
            "aria-hidden": !0,
            required: N,
            tabIndex: -1,
            name: g,
            autoComplete: y,
            value: K,
            onChange: (E) => X(E.target.value),
            disabled: T,
            form: I,
            children: [
              K === void 0 ? /* @__PURE__ */ i("option", { value: "" }) : null,
              Array.from($)
            ]
          },
          F
        ) : null
      ]
    }
  ) });
};
Ae.displayName = ee;
var Oe = "SelectTrigger", De = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, disabled: s = !1, ...c } = t, p = pe(e), a = Y(Oe, e), l = a.disabled || s, n = B(o, a.onTriggerChange), f = ue(e), g = r.useRef("touch"), [y, T, N] = st((d) => {
      const v = f().filter((h) => !h.disabled), x = v.find((h) => h.value === a.value), u = at(v, d, x);
      u !== void 0 && a.onValueChange(u.value);
    }), I = (d) => {
      l || (a.onOpenChange(!0), N()), d && (a.triggerPointerDownPosRef.current = {
        x: Math.round(d.pageX),
        y: Math.round(d.pageY)
      });
    };
    return /* @__PURE__ */ i(bt, { asChild: !0, ...p, children: /* @__PURE__ */ i(
      M.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": nt(a.value) ? "" : void 0,
        ...c,
        ref: n,
        onClick: P(c.onClick, (d) => {
          d.currentTarget.focus(), g.current !== "mouse" && I(d);
        }),
        onPointerDown: P(c.onPointerDown, (d) => {
          g.current = d.pointerType;
          const v = d.target;
          v.hasPointerCapture(d.pointerId) && v.releasePointerCapture(d.pointerId), d.button === 0 && d.ctrlKey === !1 && d.pointerType === "mouse" && (I(d), d.preventDefault());
        }),
        onKeyDown: P(c.onKeyDown, (d) => {
          const v = y.current !== "";
          !(d.ctrlKey || d.altKey || d.metaKey) && d.key.length === 1 && T(d.key), !(v && d.key === " ") && Lt.includes(d.key) && (I(), d.preventDefault());
        })
      }
    ) });
  }
);
De.displayName = Oe;
var Le = "SelectValue", ke = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, className: s, style: c, children: p, placeholder: a = "", ...l } = t, n = Y(Le, e), { onValueNodeHasChildrenChange: f } = n, g = p !== void 0, y = B(o, n.onValueNodeChange);
    return z(() => {
      f(g);
    }, [f, g]), /* @__PURE__ */ i(
      M.span,
      {
        ...l,
        ref: y,
        style: { pointerEvents: "none" },
        children: nt(n.value) ? /* @__PURE__ */ i(Ie, { children: a }) : p
      }
    );
  }
);
ke.displayName = Le;
var Ft = "SelectIcon", Be = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, children: s, ...c } = t;
    return /* @__PURE__ */ i(M.span, { "aria-hidden": !0, ...c, ref: o, children: s || "▼" });
  }
);
Be.displayName = Ft;
var Wt = "SelectPortal", Ve = (t) => /* @__PURE__ */ i(xt, { asChild: !0, ...t });
Ve.displayName = Wt;
var te = "SelectContent", He = r.forwardRef(
  (t, o) => {
    const e = Y(te, t.__scopeSelect), [s, c] = r.useState();
    if (z(() => {
      c(new DocumentFragment());
    }, []), !e.open) {
      const p = s;
      return p ? Ee.createPortal(
        /* @__PURE__ */ i(Ue, { scope: t.__scopeSelect, children: /* @__PURE__ */ i(de.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ i("div", { children: t.children }) }) }),
        p
      ) : null;
    }
    return /* @__PURE__ */ i(Fe, { ...t, ref: o });
  }
);
He.displayName = te;
var D = 10, [Ue, q] = re(te), Kt = "SelectContentImpl", $t = wt("SelectContent.RemoveScroll"), Fe = r.forwardRef(
  (t, o) => {
    const {
      __scopeSelect: e,
      position: s = "item-aligned",
      onCloseAutoFocus: c,
      onEscapeKeyDown: p,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: l,
      sideOffset: n,
      align: f,
      alignOffset: g,
      arrowPadding: y,
      collisionBoundary: T,
      collisionPadding: N,
      sticky: I,
      hideWhenDetached: d,
      avoidCollisions: v,
      //
      ...x
    } = t, u = Y(te, e), [h, A] = r.useState(null), [O, ne] = r.useState(null), R = B(o, (m) => A(m)), [L, K] = r.useState(null), [X, V] = r.useState(
      null
    ), H = ue(e), [$, U] = r.useState(!1), F = r.useRef(!1);
    r.useEffect(() => {
      if (h) return It(h);
    }, [h]), Tt();
    const E = r.useCallback(
      (m) => {
        const [b, ..._] = H().map((w) => w.ref.current), [C] = _.slice(-1), S = document.activeElement;
        for (const w of m)
          if (w === S || (w == null || w.scrollIntoView({ block: "nearest" }), w === b && O && (O.scrollTop = 0), w === C && O && (O.scrollTop = O.scrollHeight), w == null || w.focus(), document.activeElement !== S)) return;
      },
      [H, O]
    ), k = r.useCallback(
      () => E([L, h]),
      [E, L, h]
    );
    r.useEffect(() => {
      $ && k();
    }, [$, k]);
    const { onOpenChange: W, triggerPointerDownPosRef: G } = u;
    r.useEffect(() => {
      if (h) {
        let m = { x: 0, y: 0 };
        const b = (C) => {
          var S, w;
          m = {
            x: Math.abs(Math.round(C.pageX) - (((S = G.current) == null ? void 0 : S.x) ?? 0)),
            y: Math.abs(Math.round(C.pageY) - (((w = G.current) == null ? void 0 : w.y) ?? 0))
          };
        }, _ = (C) => {
          m.x <= 10 && m.y <= 10 ? C.preventDefault() : h.contains(C.target) || W(!1), document.removeEventListener("pointermove", b), G.current = null;
        };
        return G.current !== null && (document.addEventListener("pointermove", b), document.addEventListener("pointerup", _, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", b), document.removeEventListener("pointerup", _, { capture: !0 });
        };
      }
    }, [h, W, G]), r.useEffect(() => {
      const m = () => W(!1);
      return window.addEventListener("blur", m), window.addEventListener("resize", m), () => {
        window.removeEventListener("blur", m), window.removeEventListener("resize", m);
      };
    }, [W]);
    const [fe, le] = st((m) => {
      const b = H().filter((S) => !S.disabled), _ = b.find((S) => S.ref.current === document.activeElement), C = at(b, m, _);
      C && setTimeout(() => C.ref.current.focus());
    }), me = r.useCallback(
      (m, b, _) => {
        const C = !F.current && !_;
        (u.value !== void 0 && u.value === b || C) && (K(m), C && (F.current = !0));
      },
      [u.value]
    ), he = r.useCallback(() => h == null ? void 0 : h.focus(), [h]), oe = r.useCallback(
      (m, b, _) => {
        const C = !F.current && !_;
        (u.value !== void 0 && u.value === b || C) && V(m);
      },
      [u.value]
    ), ce = s === "popper" ? we : We, se = ce === we ? {
      side: l,
      sideOffset: n,
      align: f,
      alignOffset: g,
      arrowPadding: y,
      collisionBoundary: T,
      collisionPadding: N,
      sticky: I,
      hideWhenDetached: d,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ i(
      Ue,
      {
        scope: e,
        content: h,
        viewport: O,
        onViewportChange: ne,
        itemRefCallback: me,
        selectedItem: L,
        onItemLeave: he,
        itemTextRefCallback: oe,
        focusSelectedItem: k,
        selectedItemText: X,
        position: s,
        isPositioned: $,
        searchRef: fe,
        children: /* @__PURE__ */ i(Nt, { as: $t, allowPinchZoom: !0, children: /* @__PURE__ */ i(
          Pt,
          {
            asChild: !0,
            trapped: u.open,
            onMountAutoFocus: (m) => {
              m.preventDefault();
            },
            onUnmountAutoFocus: P(c, (m) => {
              var b;
              (b = u.trigger) == null || b.focus({ preventScroll: !0 }), m.preventDefault();
            }),
            children: /* @__PURE__ */ i(
              Ct,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: p,
                onPointerDownOutside: a,
                onFocusOutside: (m) => m.preventDefault(),
                onDismiss: () => u.onOpenChange(!1),
                children: /* @__PURE__ */ i(
                  ce,
                  {
                    role: "listbox",
                    id: u.contentId,
                    "data-state": u.open ? "open" : "closed",
                    dir: u.dir,
                    onContextMenu: (m) => m.preventDefault(),
                    ...x,
                    ...se,
                    onPlaced: () => U(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...x.style
                    },
                    onKeyDown: P(x.onKeyDown, (m) => {
                      const b = m.ctrlKey || m.altKey || m.metaKey;
                      if (m.key === "Tab" && m.preventDefault(), !b && m.key.length === 1 && le(m.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(m.key)) {
                        let C = H().filter((S) => !S.disabled).map((S) => S.ref.current);
                        if (["ArrowUp", "End"].includes(m.key) && (C = C.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(m.key)) {
                          const S = m.target, w = C.indexOf(S);
                          C = C.slice(w + 1);
                        }
                        setTimeout(() => E(C)), m.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Fe.displayName = Kt;
var Gt = "SelectItemAlignedPosition", We = r.forwardRef((t, o) => {
  const { __scopeSelect: e, onPlaced: s, ...c } = t, p = Y(te, e), a = q(te, e), [l, n] = r.useState(null), [f, g] = r.useState(null), y = B(o, (R) => g(R)), T = ue(e), N = r.useRef(!1), I = r.useRef(!0), { viewport: d, selectedItem: v, selectedItemText: x, focusSelectedItem: u } = a, h = r.useCallback(() => {
    if (p.trigger && p.valueNode && l && f && d && v && x) {
      const R = p.trigger.getBoundingClientRect(), L = f.getBoundingClientRect(), K = p.valueNode.getBoundingClientRect(), X = x.getBoundingClientRect();
      if (p.dir !== "rtl") {
        const S = X.left - L.left, w = K.left - S, Z = R.left - w, J = R.width + Z, ve = Math.max(J, L.width), ge = window.innerWidth - D, Se = Re(w, [
          D,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(D, ge - ve)
        ]);
        l.style.minWidth = J + "px", l.style.left = Se + "px";
      } else {
        const S = L.right - X.right, w = window.innerWidth - K.right - S, Z = window.innerWidth - R.right - w, J = R.width + Z, ve = Math.max(J, L.width), ge = window.innerWidth - D, Se = Re(w, [
          D,
          Math.max(D, ge - ve)
        ]);
        l.style.minWidth = J + "px", l.style.right = Se + "px";
      }
      const V = T(), H = window.innerHeight - D * 2, $ = d.scrollHeight, U = window.getComputedStyle(f), F = parseInt(U.borderTopWidth, 10), E = parseInt(U.paddingTop, 10), k = parseInt(U.borderBottomWidth, 10), W = parseInt(U.paddingBottom, 10), G = F + E + $ + W + k, fe = Math.min(v.offsetHeight * 5, G), le = window.getComputedStyle(d), me = parseInt(le.paddingTop, 10), he = parseInt(le.paddingBottom, 10), oe = R.top + R.height / 2 - D, ce = H - oe, se = v.offsetHeight / 2, m = v.offsetTop + se, b = F + E + m, _ = G - b;
      if (b <= oe) {
        const S = V.length > 0 && v === V[V.length - 1].ref.current;
        l.style.bottom = "0px";
        const w = f.clientHeight - d.offsetTop - d.offsetHeight, Z = Math.max(
          ce,
          se + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (S ? he : 0) + w + k
        ), J = b + Z;
        l.style.height = J + "px";
      } else {
        const S = V.length > 0 && v === V[0].ref.current;
        l.style.top = "0px";
        const Z = Math.max(
          oe,
          F + d.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (S ? me : 0) + se
        ) + _;
        l.style.height = Z + "px", d.scrollTop = b - oe + d.offsetTop;
      }
      l.style.margin = `${D}px 0`, l.style.minHeight = fe + "px", l.style.maxHeight = H + "px", s == null || s(), requestAnimationFrame(() => N.current = !0);
    }
  }, [
    T,
    p.trigger,
    p.valueNode,
    l,
    f,
    d,
    v,
    x,
    p.dir,
    s
  ]);
  z(() => h(), [h]);
  const [A, O] = r.useState();
  z(() => {
    f && O(window.getComputedStyle(f).zIndex);
  }, [f]);
  const ne = r.useCallback(
    (R) => {
      R && I.current === !0 && (h(), u == null || u(), I.current = !1);
    },
    [h, u]
  );
  return /* @__PURE__ */ i(
    jt,
    {
      scope: e,
      contentWrapper: l,
      shouldExpandOnScrollRef: N,
      onScrollButtonChange: ne,
      children: /* @__PURE__ */ i(
        "div",
        {
          ref: n,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: A
          },
          children: /* @__PURE__ */ i(
            M.div,
            {
              ...c,
              ref: y,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...c.style
              }
            }
          )
        }
      )
    }
  );
});
We.displayName = Gt;
var zt = "SelectPopperPosition", we = r.forwardRef((t, o) => {
  const {
    __scopeSelect: e,
    align: s = "start",
    collisionPadding: c = D,
    ...p
  } = t, a = pe(e);
  return /* @__PURE__ */ i(
    Rt,
    {
      ...a,
      ...p,
      ref: o,
      align: s,
      collisionPadding: c,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...p.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
we.displayName = zt;
var [jt, Ne] = re(te, {}), ye = "SelectViewport", Ke = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, nonce: s, ...c } = t, p = q(ye, e), a = Ne(ye, e), l = B(o, p.onViewportChange), n = r.useRef(0);
    return /* @__PURE__ */ Q(Ie, { children: [
      /* @__PURE__ */ i(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: s
        }
      ),
      /* @__PURE__ */ i(de.Slot, { scope: e, children: /* @__PURE__ */ i(
        M.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...c,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...c.style
          },
          onScroll: P(c.onScroll, (f) => {
            const g = f.currentTarget, { contentWrapper: y, shouldExpandOnScrollRef: T } = a;
            if (T != null && T.current && y) {
              const N = Math.abs(n.current - g.scrollTop);
              if (N > 0) {
                const I = window.innerHeight - D * 2, d = parseFloat(y.style.minHeight), v = parseFloat(y.style.height), x = Math.max(d, v);
                if (x < I) {
                  const u = x + N, h = Math.min(I, u), A = u - h;
                  y.style.height = h + "px", y.style.bottom === "0px" && (g.scrollTop = A > 0 ? A : 0, y.style.justifyContent = "flex-end");
                }
              }
            }
            n.current = g.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Ke.displayName = ye;
var $e = "SelectGroup", [Yt, qt] = re($e), Ge = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, ...s } = t, c = Te();
    return /* @__PURE__ */ i(Yt, { scope: e, id: c, children: /* @__PURE__ */ i(M.div, { role: "group", "aria-labelledby": c, ...s, ref: o }) });
  }
);
Ge.displayName = $e;
var ze = "SelectLabel", je = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, ...s } = t, c = qt(ze, e);
    return /* @__PURE__ */ i(M.div, { id: c.id, ...s, ref: o });
  }
);
je.displayName = ze;
var ie = "SelectItem", [Xt, Ye] = re(ie), qe = r.forwardRef(
  (t, o) => {
    const {
      __scopeSelect: e,
      value: s,
      disabled: c = !1,
      textValue: p,
      ...a
    } = t, l = Y(ie, e), n = q(ie, e), f = l.value === s, [g, y] = r.useState(p ?? ""), [T, N] = r.useState(!1), I = B(
      o,
      (u) => {
        var h;
        return (h = n.itemRefCallback) == null ? void 0 : h.call(n, u, s, c);
      }
    ), d = Te(), v = r.useRef("touch"), x = () => {
      c || (l.onValueChange(s), l.onOpenChange(!1));
    };
    if (s === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ i(
      Xt,
      {
        scope: e,
        value: s,
        disabled: c,
        textId: d,
        isSelected: f,
        onItemTextChange: r.useCallback((u) => {
          y((h) => h || ((u == null ? void 0 : u.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ i(
          de.ItemSlot,
          {
            scope: e,
            value: s,
            disabled: c,
            textValue: g,
            children: /* @__PURE__ */ i(
              M.div,
              {
                role: "option",
                "aria-labelledby": d,
                "data-highlighted": T ? "" : void 0,
                "aria-selected": f && T,
                "data-state": f ? "checked" : "unchecked",
                "aria-disabled": c || void 0,
                "data-disabled": c ? "" : void 0,
                tabIndex: c ? void 0 : -1,
                ...a,
                ref: I,
                onFocus: P(a.onFocus, () => N(!0)),
                onBlur: P(a.onBlur, () => N(!1)),
                onClick: P(a.onClick, () => {
                  v.current !== "mouse" && x();
                }),
                onPointerUp: P(a.onPointerUp, () => {
                  v.current === "mouse" && x();
                }),
                onPointerDown: P(a.onPointerDown, (u) => {
                  v.current = u.pointerType;
                }),
                onPointerMove: P(a.onPointerMove, (u) => {
                  var h;
                  v.current = u.pointerType, c ? (h = n.onItemLeave) == null || h.call(n) : v.current === "mouse" && u.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: P(a.onPointerLeave, (u) => {
                  var h;
                  u.currentTarget === document.activeElement && ((h = n.onItemLeave) == null || h.call(n));
                }),
                onKeyDown: P(a.onKeyDown, (u) => {
                  var A;
                  ((A = n.searchRef) == null ? void 0 : A.current) !== "" && u.key === " " || (kt.includes(u.key) && x(), u.key === " " && u.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
qe.displayName = ie;
var ae = "SelectItemText", Xe = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, className: s, style: c, ...p } = t, a = Y(ae, e), l = q(ae, e), n = Ye(ae, e), f = Ut(ae, e), [g, y] = r.useState(null), T = B(
      o,
      (x) => y(x),
      n.onItemTextChange,
      (x) => {
        var u;
        return (u = l.itemTextRefCallback) == null ? void 0 : u.call(l, x, n.value, n.disabled);
      }
    ), N = g == null ? void 0 : g.textContent, I = r.useMemo(
      () => /* @__PURE__ */ i("option", { value: n.value, disabled: n.disabled, children: N }, n.value),
      [n.disabled, n.value, N]
    ), { onNativeOptionAdd: d, onNativeOptionRemove: v } = f;
    return z(() => (d(I), () => v(I)), [d, v, I]), /* @__PURE__ */ Q(Ie, { children: [
      /* @__PURE__ */ i(M.span, { id: n.textId, ...p, ref: T }),
      n.isSelected && a.valueNode && !a.valueNodeHasChildren ? Ee.createPortal(p.children, a.valueNode) : null
    ] });
  }
);
Xe.displayName = ae;
var Ze = "SelectItemIndicator", Je = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, ...s } = t;
    return Ye(Ze, e).isSelected ? /* @__PURE__ */ i(M.span, { "aria-hidden": !0, ...s, ref: o }) : null;
  }
);
Je.displayName = Ze;
var xe = "SelectScrollUpButton", Qe = r.forwardRef((t, o) => {
  const e = q(xe, t.__scopeSelect), s = Ne(xe, t.__scopeSelect), [c, p] = r.useState(!1), a = B(o, s.onScrollButtonChange);
  return z(() => {
    if (e.viewport && e.isPositioned) {
      let l = function() {
        const f = n.scrollTop > 0;
        p(f);
      };
      const n = e.viewport;
      return l(), n.addEventListener("scroll", l), () => n.removeEventListener("scroll", l);
    }
  }, [e.viewport, e.isPositioned]), c ? /* @__PURE__ */ i(
    tt,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: n } = e;
        l && n && (l.scrollTop = l.scrollTop - n.offsetHeight);
      }
    }
  ) : null;
});
Qe.displayName = xe;
var Ce = "SelectScrollDownButton", et = r.forwardRef((t, o) => {
  const e = q(Ce, t.__scopeSelect), s = Ne(Ce, t.__scopeSelect), [c, p] = r.useState(!1), a = B(o, s.onScrollButtonChange);
  return z(() => {
    if (e.viewport && e.isPositioned) {
      let l = function() {
        const f = n.scrollHeight - n.clientHeight, g = Math.ceil(n.scrollTop) < f;
        p(g);
      };
      const n = e.viewport;
      return l(), n.addEventListener("scroll", l), () => n.removeEventListener("scroll", l);
    }
  }, [e.viewport, e.isPositioned]), c ? /* @__PURE__ */ i(
    tt,
    {
      ...t,
      ref: a,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: n } = e;
        l && n && (l.scrollTop = l.scrollTop + n.offsetHeight);
      }
    }
  ) : null;
});
et.displayName = Ce;
var tt = r.forwardRef((t, o) => {
  const { __scopeSelect: e, onAutoScroll: s, ...c } = t, p = q("SelectScrollButton", e), a = r.useRef(null), l = ue(e), n = r.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return r.useEffect(() => () => n(), [n]), z(() => {
    var g;
    const f = l().find((y) => y.ref.current === document.activeElement);
    (g = f == null ? void 0 : f.ref.current) == null || g.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ i(
    M.div,
    {
      "aria-hidden": !0,
      ...c,
      ref: o,
      style: { flexShrink: 0, ...c.style },
      onPointerDown: P(c.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(s, 50));
      }),
      onPointerMove: P(c.onPointerMove, () => {
        var f;
        (f = p.onItemLeave) == null || f.call(p), a.current === null && (a.current = window.setInterval(s, 50));
      }),
      onPointerLeave: P(c.onPointerLeave, () => {
        n();
      })
    }
  );
}), Zt = "SelectSeparator", ot = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, ...s } = t;
    return /* @__PURE__ */ i(M.div, { "aria-hidden": !0, ...s, ref: o });
  }
);
ot.displayName = Zt;
var be = "SelectArrow", Jt = r.forwardRef(
  (t, o) => {
    const { __scopeSelect: e, ...s } = t, c = pe(e), p = Y(be, e), a = q(be, e);
    return p.open && a.position === "popper" ? /* @__PURE__ */ i(_t, { ...c, ...s, ref: o }) : null;
  }
);
Jt.displayName = be;
var Qt = "SelectBubbleInput", rt = r.forwardRef(
  ({ __scopeSelect: t, value: o, ...e }, s) => {
    const c = r.useRef(null), p = B(s, c), a = Dt(o);
    return r.useEffect(() => {
      const l = c.current;
      if (!l) return;
      const n = window.HTMLSelectElement.prototype, g = Object.getOwnPropertyDescriptor(
        n,
        "value"
      ).set;
      if (a !== o && g) {
        const y = new Event("change", { bubbles: !0 });
        g.call(l, o), l.dispatchEvent(y);
      }
    }, [a, o]), /* @__PURE__ */ i(
      M.select,
      {
        ...e,
        style: { ...Mt, ...e.style },
        ref: p,
        defaultValue: o
      }
    );
  }
);
rt.displayName = Qt;
function nt(t) {
  return t === "" || t === void 0;
}
function st(t) {
  const o = St(t), e = r.useRef(""), s = r.useRef(0), c = r.useCallback(
    (a) => {
      const l = e.current + a;
      o(l), (function n(f) {
        e.current = f, window.clearTimeout(s.current), f !== "" && (s.current = window.setTimeout(() => n(""), 1e3));
      })(l);
    },
    [o]
  ), p = r.useCallback(() => {
    e.current = "", window.clearTimeout(s.current);
  }, []);
  return r.useEffect(() => () => window.clearTimeout(s.current), []), [e, c, p];
}
function at(t, o, e) {
  const c = o.length > 1 && Array.from(o).every((f) => f === o[0]) ? o[0] : o, p = e ? t.indexOf(e) : -1;
  let a = eo(t, Math.max(p, 0));
  c.length === 1 && (a = a.filter((f) => f !== e));
  const n = a.find(
    (f) => f.textValue.toLowerCase().startsWith(c.toLowerCase())
  );
  return n !== e ? n : void 0;
}
function eo(t, o) {
  return t.map((e, s) => t[(o + s) % t.length]);
}
var to = Ae, lt = De, oo = ke, ro = Be, no = Ve, ct = He, so = Ke, ao = Ge, it = je, dt = qe, lo = Xe, co = Je, ut = Qe, pt = et, ft = ot;
const Po = to, Ro = ao, Eo = oo, io = r.forwardRef(({ className: t, children: o, ...e }, s) => /* @__PURE__ */ Q(
  lt,
  {
    ref: s,
    className: j(
      "flex h-11 w-full items-center justify-between rounded-[var(--shape-radius-xl)] border border-border/80 bg-card px-[calc(var(--density-padding)*1.05)] py-[calc(var(--density-padding)*0.72)] text-sm text-foreground shadow-sm transition-[border-color,box-shadow,background-color,color] duration-fast ease-smooth ring-offset-background placeholder:text-muted-foreground/85 focus-visible:outline-none focus-visible:border-primary/80 focus-visible:ring-4 focus-visible:ring-primary/20 disabled:cursor-not-allowed disabled:opacity-80 disabled:bg-muted/35 [&>span]:line-clamp-1 data-[placeholder]:text-muted-foreground/85",
      t
    ),
    ...e,
    children: [
      o,
      /* @__PURE__ */ i(ro, { asChild: !0, children: /* @__PURE__ */ i(Me, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
io.displayName = lt.displayName;
const mt = r.forwardRef(({ className: t, ...o }, e) => /* @__PURE__ */ i(
  ut,
  {
    ref: e,
    className: j(
      "flex cursor-default items-center justify-center py-1",
      t
    ),
    ...o,
    children: /* @__PURE__ */ i(At, { className: "h-4 w-4" })
  }
));
mt.displayName = ut.displayName;
const ht = r.forwardRef(({ className: t, ...o }, e) => /* @__PURE__ */ i(
  pt,
  {
    ref: e,
    className: j(
      "flex cursor-default items-center justify-center py-1",
      t
    ),
    ...o,
    children: /* @__PURE__ */ i(Me, { className: "h-4 w-4" })
  }
));
ht.displayName = pt.displayName;
const uo = r.forwardRef(({ className: t, children: o, position: e = "popper", ...s }, c) => /* @__PURE__ */ i(no, { children: /* @__PURE__ */ Q(
  ct,
  {
    ref: c,
    className: j(
      "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-[var(--shape-radius-lg)] border border-border bg-popover text-popover-foreground shadow-elevation-2 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      t
    ),
    position: e,
    ...s,
    children: [
      /* @__PURE__ */ i(mt, {}),
      /* @__PURE__ */ i(
        so,
        {
          className: j(
            "p-1",
            e === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: o
        }
      ),
      /* @__PURE__ */ i(ht, {})
    ]
  }
) }));
uo.displayName = ct.displayName;
const po = r.forwardRef(({ className: t, ...o }, e) => /* @__PURE__ */ i(
  it,
  {
    ref: e,
    className: j("py-1.5 ps-8 pe-2 text-xs font-semibold tracking-wide uppercase text-muted-foreground", t),
    ...o
  }
));
po.displayName = it.displayName;
const fo = r.forwardRef(({ className: t, children: o, ...e }, s) => /* @__PURE__ */ Q(
  dt,
  {
    ref: s,
    className: j(
      "relative flex w-full cursor-default select-none items-center rounded-[var(--shape-radius-sm)] py-1.5 ps-8 pe-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...e,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center rtl:right-2 rtl:left-auto", children: /* @__PURE__ */ i(co, { children: /* @__PURE__ */ i(Ot, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ i(lo, { children: o })
    ]
  }
));
fo.displayName = dt.displayName;
const mo = r.forwardRef(({ className: t, ...o }, e) => /* @__PURE__ */ i(
  ft,
  {
    ref: e,
    className: j("-mx-1 my-1 h-px bg-border", t),
    ...o
  }
));
mo.displayName = ft.displayName;
export {
  Po as S,
  Ro as a,
  Eo as b,
  io as c,
  uo as d,
  po as e,
  fo as f,
  mo as g,
  mt as h,
  ht as i
};
